<template>
  <div class="container">
    <div v-if="isShow === true">
      <CardPopupImg
        :cardContent="popUpData"
        :isModalVisible="isShow"
        :cardType="cardType"
      />
    </div>
    <CRow alignHorizontal="end" alignVertical="center">
      <div
        class="containerIconClose"
        @click="close(cardContent.navigate.close.action)"
      >
        <font-awesome-icon icon="times" class="IconClose" />
      </div>
    </CRow>

    <CCard class="customCard">
      <CCardHeader class="customCardHeaderActive">
        <CRow
          alignHorizontal="between"
          alignVertical="center"
          class="mr-2 ml-2"
        >
          <h3 :class="checkLangClass() + ' m-2'">
            {{ checkLanguage(cardContent.title) }} :
            {{ checkLanguage(cardContent.description) }}
          </h3>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CRow alignVertical="center" alignHorizontal="center">
          <template v-if="checkWidth >= 1039">
            <video
              class="video-js"
              :src="baseUrl + pathVideoIpad"
              width="100%"
              controls
            />
          </template>
          <template v-else-if="checkWidth <= 1038 && checkWidth >= 500">
            <video
              class="video-js"
              :src="baseUrl + pathVideoIpad"
              width="100%"
              controls
            />
          </template>
          <template v-else-if="checkWidth < 500">
            <video
              class="video-js"
              :src="baseUrl + pathVideoIpad"
              width="100%"
              controls
            />
          </template>
        </CRow>
        <CRow
          alignVertical="center"
          alignHorizontal="center"
          class="BTNNextPrev"
        >
          <div class>
            <CButton
              class="ButtonCustomLeft"
              block
              color="danger"
              shape="pill"
              size="lg"
              @click="funcRoute(cardContent.navigate.previous.action, 0)"
              >PREV</CButton
            >
          </div>
          <div class>
            <CButton
              @click="funcRoute(cardContent.navigate.next.action, 1)"
              class="ButtonCustomRight"
              block
              color="success"
              shape="pill"
              size="lg"
              >NEXT</CButton
            >
          </div>
        </CRow>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import CardPopupImg from "./CardPopupImg";
import { mapGetters } from "vuex";

import "../../../assets/scss/_chineseStyle.scss";
import "../../../assets/scss/_chineseIcon.scss";

export default {
  name: "CardVideo",
  components: { CardPopupImg },
  props: {
    isAddQueueShow: Boolean,
    setAddQueueVisible: Function,
    cardContent: Object,
    func: Function,
    openModal: Function,
    pathVideoIpad: String,
    checkWidth: Number,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_URL_SOUND,
      lang: "",
      isShow: false,
      popUpData: {},
      cardType: "text",
    };
  },
  computed: {
    ...mapGetters({
      getLanguage: "language/getLanguage",
      getPopUp: "template/getPopupData",
    }),
  },
  watch: {
    getLanguage: function(val) {
      this.lang = val;
    },
    getPopUp: function(val) {
      this.popUpData = val;
      this.isShow = true;
    },
  },
  mounted() {},
  created() {
    this.lang = this.$store.state.language.language;
  },
  beforeDestroy() {},
  methods: {
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
    checkLanguage(val) {
      if (val) {
        for (let i = 0; i <= val.length; i++) {
          if (val[i].key == this.lang) {
            return val[i].value;
          }
        }
      } else {
      }
    },
    funcRoute(tempId, type) {
      let str = tempId.split("-");
      if (type == 0) {
        if (str[0] == "CTV01") {
          this.$emit("returnData", tempId);
          this.$router.push("/" + str[0] + "/" + str[1]);
        } else {
          this.$router.push("/" + str[0] + "/" + str[1]);
        }
      } else if (type == 1) {
        if (str[0] == "CTV01") {
          this.$emit("returnData", tempId);
        } else {
          this.$emit("nextRoute", tempId);
        }
      }
    },
    close(path) {
      let str = path.split("-");
      this.$router.push("/" + str[0] + "/" + str[1]);
    },
    TestModal() {
      this.isAddQueueShow = !this.isAddQueueShow;
    },
  },
};
</script>

<style>
.BTNNextPrev {
  padding-top: 5%;
}
.ButtonCustomLeft {
  margin-right: 20px;
}
.ButtonCustomRight {
  margin-left: 20px;
}
</style>
